import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PATHS } from './paths';

import PostManagement from '../Page/PostManagement';
import DonorManagement from '../Page/DonorManagement';
import PaymentStatus from '../Page/PaymentStatus';
import ProjectManagement from '../Page/ProjectManagement/index';
import ProjectSettings from '../Page/ProjectSettings';
import NewProject from '../Page/NewProject';
import MyAccount from '../Page/MyAccount';
import Login from '../Page/Login';
import Signup from '../Page/Signup';
import AuthGuard from './AuthGuard';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={PATHS.LOGIN} element={<Login />} />
      <Route path={PATHS.SIGNUP} element={<Signup />} />

      {/* Protected Routes */}
      <Route element={<AuthGuard />}>
        <Route path={PATHS.DASHBOARD} element={<Navigate to={PATHS.PROJECT_MANAGEMENT} replace />} />
        <Route path={PATHS.POST_MANAGEMENT} element={<PostManagement />} />
        <Route path={PATHS.DONOR_MANAGEMENT} element={<DonorManagement />} />
        <Route path={PATHS.PAYMENT_STATUS} element={<PaymentStatus />} />
        <Route path={PATHS.PROJECT_MANAGEMENT} element={<ProjectManagement />} />
        <Route path={PATHS.PROJECT_SETTINGS} element={<ProjectSettings />} />
        <Route path={PATHS.NEW_PROJECT} element={<NewProject />} />
        <Route path={PATHS.MY_ACCOUNT} element={<MyAccount />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;


